import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const ApplicationSupport = () => {
  return (
    <>
      <Helmet>
        <title>Application Support Services - Ursus Victor LLC</title>
        <meta name="description" content="Professional loan application assistance services. Get expert help completing your loan application accurately and efficiently." />
      </Helmet>

      {/* Hero */}
      <section style={{
        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
        color: 'white',
        padding: '5rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <div style={{fontSize: '4rem', marginBottom: '1rem'}}>📝</div>
          <h1 style={{fontSize: '3.5rem', fontWeight: '900', marginBottom: '1.5rem'}}>
            Application Support Services
          </h1>
          <p style={{fontSize: '1.3rem', opacity: 0.95, lineHeight: '1.7'}}>
            Expert guidance through every step of the loan application process
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section style={{padding: '5rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '1000px', margin: '0 auto'}}>
          <div style={{marginBottom: '4rem'}}>
            <h2 style={{fontSize: '2.5rem', fontWeight: '900', color: '#1e3a8a', marginBottom: '1.5rem'}}>
              Comprehensive Application Assistance
            </h2>
            <p style={{fontSize: '1.15rem', color: '#475569', lineHeight: '1.9', marginBottom: '1.5rem'}}>
              Completing a loan application can be complex and time-consuming. Our application support services 
              provide expert guidance to help you navigate the process with confidence. We ensure your application 
              is complete, accurate, and presents your financial situation in the best possible light.
            </p>
            <div style={{
              background: '#fef3c7',
              padding: '1.5rem',
              borderRadius: '12px',
              border: '2px solid #f59e0b'
            }}>
              <p style={{color: '#92400e', fontWeight: '700', margin: 0}}>
                ⚠️ We provide application support services only. We are NOT a lender and do NOT make lending decisions.
              </p>
            </div>
          </div>

          {/* What's Included */}
          <div style={{marginBottom: '4rem'}}>
            <h3 style={{fontSize: '2rem', fontWeight: '800', color: '#1e40af', marginBottom: '2rem'}}>
              What's Included
            </h3>
            <div style={{display: 'grid', gap: '1.5rem'}}>
              {[
                {
                  title: 'Form Completion Assistance',
                  desc: 'Step-by-step guidance completing all required application forms accurately'
                },
                {
                  title: 'Requirement Clarification',
                  desc: 'Clear explanations of what lenders are asking for and why'
                },
                {
                  title: 'Information Verification',
                  desc: 'Review of all entered information to ensure accuracy and consistency'
                },
                {
                  title: 'Error Prevention',
                  desc: 'Identification and correction of common mistakes before submission'
                },
                {
                  title: 'Question Support',
                  desc: 'Answers to your questions throughout the application process'
                },
                {
                  title: 'Submission Preparation',
                  desc: 'Final review and guidance on proper submission procedures'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  background: '#f8fafc',
                  padding: '2rem',
                  borderRadius: '12px',
                  border: '2px solid #e2e8f0',
                  borderLeft: '5px solid #3b82f6'
                }}>
                  <h4 style={{fontSize: '1.4rem', fontWeight: '800', color: '#1e40af', marginBottom: '0.75rem'}}>
                    {item.title}
                  </h4>
                  <p style={{color: '#64748b', lineHeight: '1.7', fontSize: '1.05rem'}}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Process */}
          <div style={{marginBottom: '4rem'}}>
            <h3 style={{fontSize: '2rem', fontWeight: '800', color: '#1e40af', marginBottom: '2rem'}}>
              Our Process
            </h3>
            <div style={{display: 'grid', gap: '1.5rem'}}>
              {[
                { step: '1', title: 'Initial Review', desc: 'We review the application requirements for your specific loan type' },
                { step: '2', title: 'Guided Completion', desc: 'We guide you through each section of the application' },
                { step: '3', title: 'Accuracy Check', desc: 'We verify all information for accuracy and completeness' },
                { step: '4', title: 'Final Review', desc: 'Comprehensive review before submission' }
              ].map((item, index) => (
                <div key={index} style={{
                  display: 'flex',
                  gap: '1.5rem',
                  alignItems: 'center',
                  padding: '1.5rem',
                  background: '#f8fafc',
                  borderRadius: '12px',
                  border: '2px solid #e2e8f0'
                }}>
                  <div style={{
                    background: '#3b82f6',
                    color: 'white',
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.8rem',
                    fontWeight: '900',
                    flexShrink: 0
                  }}>
                    {item.step}
                  </div>
                  <div>
                    <h4 style={{fontSize: '1.3rem', fontWeight: '800', color: '#1e40af', marginBottom: '0.5rem'}}>
                      {item.title}
                    </h4>
                    <p style={{color: '#64748b', lineHeight: '1.7'}}>
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div style={{
            background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
            padding: '3rem',
            borderRadius: '16px',
            border: '3px solid #3b82f6',
            textAlign: 'center'
          }}>
            <h3 style={{fontSize: '2rem', fontWeight: '900', color: '#1e3a8a', marginBottom: '1rem'}}>
              Ready to Get Started?
            </h3>
            <p style={{fontSize: '1.15rem', color: '#475569', marginBottom: '2rem', lineHeight: '1.7'}}>
              Let us help you complete your loan application with confidence
            </p>
            <Link to="/contact" style={{
              background: '#1e40af',
              color: 'white',
              padding: '1.25rem 3rem',
              borderRadius: '12px',
              fontWeight: '800',
              fontSize: '1.2rem',
              display: 'inline-block'
            }}>
              Request Support
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ApplicationSupport;
